// extracted by mini-css-extract-plugin
export default {"profile-picture":"chat-picture_profile-picture__zjUkD","svg-icon":"chat-picture_svg-icon__2XKQb"};